var render, staticRenderFns
import script from "./tag-list.vue?vue&type=script&lang=js"
export * from "./tag-list.vue?vue&type=script&lang=js"
import style0 from "./tag-list.vue?vue&type=style&index=0&id=62324874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62324874",
  null
  
)

export default component.exports